import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceBehfaConfirmUploaded',
  templateUrl: './DeviceBehfaConfirmUploaded.component.html',
  styleUrls: ['./DeviceBehfaConfirmUploaded.component.scss']
})
export class DeviceBehfaConfirmUploadedComponent implements OnInit {

  Token:String=""

  page:number=0;
  Procssing:boolean=false;
  InProccessing:boolean=false;

  OperationDsc:String=""
  Operation:number
  Operation_id:number
  modalRef_operation: any;

  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  constructor(
    private DeviceBehfa_Service:DeviceBehfaService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,54).subscribe(
      data=>{
        this.ReadData_DeviceBehfa()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_DeviceBehfa(){
    this.Procssing=true
    this.DeviceBehfa_Service.GetRecordConfirmUpload(this.Token).subscribe(
      data=>{
        this.DataList_DeviceBehfa=data
        this.Procssing=false

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Confirm(){
    this.DeviceBehfa_Service.ConfirmUpload(this.Operation_id,this.Operation,this.OperationDsc,this.Token).subscribe(
      data=>{
        this.modalRef_operation.hide()
        this.OperationDsc=''
        this.Alertify_Service.SuccessMessage("Approved successfully.")
        this.ReadData_DeviceBehfa()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ConfirmList(){
    this.DeviceBehfa_Service.ConfirmUploadList(this.ids,this.Operation,this.OperationDsc,this.Token).subscribe(
      data=>{
        this.modalRef_operation.hide()
        this.OperationDsc=''
        this.ids='-1'
        this.Alertify_Service.SuccessMessage("Approved successfully.")
        this.ReadData_DeviceBehfa()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  openModal(template: TemplateRef<any>,Operation:number,Operation_id:number) {
    this.modalRef_operation = this.modalService.show(template);
    this.Operation=Operation
    this.Operation_id=Operation_id
  }

  
  //#region  CheckAll

  ids:String="-1"

  Check_All:boolean=false
  onChange_CheckAll(){
    this.Check_All=!this.Check_All
    if(this.Check_All)
    {
      for(let item of this.DataList_DeviceBehfa)
      {
        item.selected=true
      }
    }
    else{
      for(let item of this.DataList_DeviceBehfa)
      {
        item.selected=false
      }
    }

    this.set_Selected_Subscription()
  }

  onChange_CheckItem(item:DeviceBehfa_Interface)
  {
    item.selected=!item.selected
    if(item.selected==false)
    {
      this.Check_All=false
    }

    this.set_Selected_Subscription()
  }

  set_Selected_Subscription(){
    this.ids='-1'
    for(let item of this.DataList_DeviceBehfa)
    {
      if(item.selected)
      {
        this.ids=this.ids+","+item.id
      }
    }
  }

  //#endregion



}
